import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { handle } from '../../../common/event-emitter/handle';
import { registerHandler } from '../../../common/event-emitter/register-handler';
import { HarvestScheduler } from '../../../common/harvest/harvest-scheduler';
import { warn } from '../../../common/util/console';
import { stringify } from '../../../common/util/stringify';
import { SUPPORTABILITY_METRIC_CHANNEL } from '../../metrics/constants';
import { AggregateBase } from '../../utils/aggregate-base';
import { FEATURE_NAME, LOGGING_EVENT_EMITTER_CHANNEL, LOG_LEVELS } from '../constants';
import { Log } from '../shared/log';
import { isValidLogLevel } from '../shared/utils';
import { applyFnToProps } from '../../../common/util/traverse';
import { MAX_PAYLOAD_SIZE } from '../../../common/constants/agent-constants';
import { FEATURE_TO_ENDPOINT } from '../../../loaders/features/features';
export var Aggregate = /*#__PURE__*/function (_AggregateBase) {
  _inherits(Aggregate, _AggregateBase);

  var _super = _createSuper(Aggregate);

  function Aggregate(agentRef) {
    var _this;

    _classCallCheck(this, Aggregate);

    _this = _super.call(this, agentRef, FEATURE_NAME);
    _this.harvestTimeSeconds = agentRef.init.logging.harvestTimeSeconds;

    _this.waitForFlags([]).then(function () {
      _this.scheduler = new HarvestScheduler(FEATURE_TO_ENDPOINT[_this.featureName], {
        onFinished: function onFinished(result) {
          return _this.postHarvestCleanup(result.sent && result.retry);
        },
        retryDelay: _this.harvestTimeSeconds,
        getPayload: function getPayload(options) {
          return _this.makeHarvestPayload(options.retry);
        },
        raw: true
      }, _assertThisInitialized(_this));
      /** emitted by instrument class (wrapped loggers) or the api methods directly */

      registerHandler(LOGGING_EVENT_EMITTER_CHANNEL, _this.handleLog.bind(_assertThisInitialized(_this)), _this.featureName, _this.ee);

      _this.drain();
      /** harvest immediately once started to purge pre-load logs collected */


      _this.scheduler.startTimer(_this.harvestTimeSeconds, 0);
    });

    return _this;
  }

  _createClass(Aggregate, [{
    key: "handleLog",
    value: function handleLog(timestamp, message) {
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : LOG_LEVELS.INFO;
      if (this.blocked) return;
      if (!attributes || _typeof(attributes) !== 'object') attributes = {};
      if (typeof level === 'string') level = level.toUpperCase();
      if (!isValidLogLevel(level)) return warn(30, level);

      try {
        if (typeof message !== 'string') {
          var stringified = stringify(message);
          /**
             * Error instances convert to `{}` when stringified
             * Symbol converts to '' when stringified
             * other cases tbd
             * */

          if (!!stringified && stringified !== '{}') message = stringified;else message = String(message);
        }
      } catch (err) {
        warn(16, message);
        return;
      }

      if (typeof message !== 'string' || !message) return warn(32);
      var log = new Log(Math.floor(this.agentRef.runtime.timeKeeper.correctRelativeTimestamp(timestamp)), message, attributes, level);
      var logBytes = log.message.length + stringify(log.attributes).length + log.level.length + 10; // timestamp == 10 chars

      var failToHarvestMessage = 'Logging/Harvest/Failed/Seen';

      if (logBytes > MAX_PAYLOAD_SIZE) {
        // cannot possibly send this, even with an empty buffer
        handle(SUPPORTABILITY_METRIC_CHANNEL, [failToHarvestMessage, logBytes]);
        warn(31, log.message.slice(0, 25) + '...');
        return;
      }

      if (this.events.wouldExceedMaxSize(logBytes)) {
        handle(SUPPORTABILITY_METRIC_CHANNEL, ['Logging/Harvest/Early/Seen', this.events.bytes + logBytes]);
        this.scheduler.runHarvest(); // force a harvest to try adding again
      }

      if (!this.events.add(log)) {
        // still failed after a harvest attempt despite not being too large would mean harvest failed with options.retry
        handle(SUPPORTABILITY_METRIC_CHANNEL, [failToHarvestMessage, logBytes]);
        warn(31, log.message.slice(0, 25) + '...');
      }
    }
  }, {
    key: "serializer",
    value: function serializer(eventBuffer) {
      var _this$agentRef$runtim, _this$agentRef$runtim2, _this$agentRef$runtim3;

      var sessionEntity = this.agentRef.runtime.session;
      return [{
        common: {
          /** Attributes in the `common` section are added to `all` logs generated in the payload */
          attributes: _objectSpread(_objectSpread({
            'entity.guid': (_this$agentRef$runtim = this.agentRef.runtime.appMetadata) === null || _this$agentRef$runtim === void 0 ? void 0 : (_this$agentRef$runtim2 = _this$agentRef$runtim.agents) === null || _this$agentRef$runtim2 === void 0 ? void 0 : (_this$agentRef$runtim3 = _this$agentRef$runtim2[0]) === null || _this$agentRef$runtim3 === void 0 ? void 0 : _this$agentRef$runtim3.entityGuid
          }, sessionEntity && {
            session: sessionEntity.state.value || '0',
            // The session ID that we generate and keep across page loads
            hasReplay: sessionEntity.state.sessionReplayMode === 1,
            // True if a session replay recording is running
            hasTrace: sessionEntity.state.sessionTraceMode === 1 // True if a session trace recording is running

          }), {}, {
            ptid: this.agentRef.runtime.ptid,
            // page trace id
            appId: this.agentRef.info.applicationID,
            // Application ID from info object,
            standalone: Boolean(this.agentRef.info.sa),
            // copy paste (true) vs APM (false)
            agentVersion: this.agentRef.runtime.version,
            // browser agent version
            // The following 3 attributes are evaluated and dropped at ingest processing time and do not get stored on NRDB:
            'instrumentation.provider': 'browser',
            'instrumentation.version': this.agentRef.runtime.version,
            'instrumentation.name': this.agentRef.runtime.loaderType
          })
        },

        /** logs section contains individual unique log entries */
        logs: applyFnToProps(eventBuffer, this.obfuscator.obfuscateString.bind(this.obfuscator), 'string')
      }];
    }
  }, {
    key: "queryStringsBuilder",
    value: function queryStringsBuilder() {
      return {
        browser_monitoring_key: this.agentRef.info.licenseKey
      };
    }
  }]);

  return Aggregate;
}(AggregateBase);

_defineProperty(Aggregate, "featureName", FEATURE_NAME);